console.log('group-booking.js v0.1.1');

import '../pages/group-booking/group-booking.js';
